import { Map } from "immutable";
import coberturaCompletaAction from "./actions";

const categorizePolicies = (policies, proposedIndex) => {
  console.log("beggining of policy class", policies)
  let bestPrice = Infinity;
  let bestCoverage = Infinity;
  let bestPriceIndex = -1;
  let bestCoverageIndex = -1;
  // Find the indexes for best price and best coverage

  policies = policies.filter((item) => item.special_class !== "special_class");
  policies = policies.filter(
    (item) => item.special_class !== "second_best_coverage"
  );
  policies = policies.filter((item) => {
    // Check for the absence of error and presence of opcion1, opcion2, opcion3 keys
    return !item.error && item.opcion1 && item.opcion2 && item.opcion3;
  });
  policies.forEach((policy, index) => {
    if (policy.opcion1 && policy.opcion1.total < bestPrice) {
      bestPrice = policy.opcion1.total;
      bestPriceIndex = index;
    }
    if (
      policy.opcion3 &&
      policy.opcion3.colision &&
      policy.opcion3.colision.deducible < bestCoverage
    ) {
      bestCoverage = policy.opcion3.colision.deducible;
      bestCoverageIndex = index;
    }
  });

  // Assign categories
  policies.forEach((policy, index) => {
    policy.clasification = "sin_clasificacion"; // Default category

    if (index === bestCoverageIndex) {
      policy.clasification = "mayor_cobertura";
    }

    if (index === bestPriceIndex) {
      policy.clasification = "mejor_precio";
    }

    if (index === bestPriceIndex && index === bestCoverageIndex) {
      policy.clasification = "mejor_precio_cobertura";
    }

    if (policy.aseguradora_cot === "SURA") {
      policy.clasification = "mejor_valor";
      if (index === bestPriceIndex) {
        policy.clasification = "mejor_precio_valor";
      }
    }
  });

  // Check for mejor_precio_cobertura and adjust

  const indexMejorPrecioCobertura = policies.findIndex(
    (policy) => policy.clasification === "mejor_precio_cobertura"
  );
  if (indexMejorPrecioCobertura !== -1) {
    const mejorPrecioCoberturaPolicy = policies[indexMejorPrecioCobertura];
    // Add a copy classified as mayor_cobertura
    const mayorCoberturaCopy = {
      ...mejorPrecioCoberturaPolicy,
      clasification: "mayor_cobertura",
      special_class: "special_class",
    };
    policies.push(mayorCoberturaCopy);
    // // Change original mejor_precio_cobertura to mejor_precio
    policies[indexMejorPrecioCobertura].clasification = "mejor_precio";
  }

  let secondBestCoverageSelect = [...policies].sort(
    (a, b) => a.opcion3.colision.deducible - b.opcion3.colision.deducible
  );
  // let findItHasBestCoverage = policies.findIndex(r=> r.clasification === 'mayor_cobertura')

  if (secondBestCoverageSelect.length > 1) {
    if (
      secondBestCoverageSelect[0].quoteId !==
      secondBestCoverageSelect[1].quoteId
    ) {
      let willpush = {
        ...secondBestCoverageSelect[1],
        // clasification: findItHasBestCoverage > -1 ? 'second_best_coverage' : 'mayor_cobertura',
        // special_class: findItHasBestCoverage > -1 ? 'second_best_coverage' : ''
        clasification: "second_best_coverage",
        special_class: "second_best_coverage",
      };
      policies.push(willpush);
    }
  }

  if (secondBestCoverageSelect.length > 2) {
    if (
      secondBestCoverageSelect[0].quoteId ===
      secondBestCoverageSelect[1].quoteId
    ) {
      let willpush = {
        ...secondBestCoverageSelect[2],
        clasification: "second_best_coverage",
        special_class: "second_best_coverage",
      };

      policies.push(willpush);
    }
  }

  // Filter the array to ensure only one sin_clasificacion is kept
  policies = policies.reduce((accumulator, currentPolicy) => {
    // Check if we already have a sin_clasificacion in the accumulator
    const hasSinClasificacion = accumulator.some(
      (policy) => policy.clasification === "sin_clasificacion"
    );
    // If we encounter a sin_clasificacion and it's already in the accumulator, skip it
    if (
      currentPolicy.clasification === "sin_clasificacion" &&
      hasSinClasificacion
    ) {
      return accumulator;
    }

    // Otherwise, include this policy in the accumulator
    accumulator.push(currentPolicy);
    return accumulator;
  }, []);

  let hasSinClasificacion = policies.findIndex(
    (r) => r.clasification === "sin_clasificacion"
  );

  if (policies.length > 3 && hasSinClasificacion === -1) {
    let lastPolicy = policies[policies.length - 1];
    let policy_to_push = {
      ...lastPolicy,
      clasification: "sin_clasificacion",
    };
    policies.push(policy_to_push);
  }

  // Sort policies based on the category priority and price for non_categorized
  policies.sort((a, b) => {
    const categoryPriority = {
      mejor_precio_valor: 1,
      mejor_precio: 2,
      mejor_valor: 3,
      mayor_cobertura: 4,
      sin_clasificacion: 5,
      second_best_coverage: 6,
    };

    if (
      categoryPriority[a.clasification] === categoryPriority[b.clasification]
    ) {
      // For non_categorized policies, sort by price
      if (a.clasification === "sin_clasificacion") {
        return a.opcion1?.total - b.opcion1?.total;
      }
      return 1; // Keep same-category items in their original order if not non_categorized
    }

    return (
      categoryPriority[a.clasification] - categoryPriority[b.clasification]
    );
  });

  // assign index
  policies = policies.map((i, ind) => {
    return {
      ...i,
      policyIndex: ind + 1,
      index: proposedIndex + ind + 1,
    };
  });

  console.log("end of policy class", policies)
  return policies;
};

const selectseguro = {};

const initState = new Map({
  selectseguro,
  cc_quotes: [],
  cc_quotes_limite2: [],
  cc_quotes_limite3: [],
  cc_quotes_category_intercom: {},
  cc_quote_selected_intercom: {},
  cyber_form_completed_cc: "",
  cyber_form_data_cc: "",
  cyber_post_response_cc: "",
  emision_response_cc: "",
  emision_error_message_cc: "",
  cc_deducible: "opcion3",
  cc_quotes_referral: {},
  cc_quotes_referral: {},
  cc_quote_id: "",
  cc_data_user: {},
  inspectionId: "",
  policyCounter: 0,
});

export default function segurosCCReducer(state = initState, action) {
  const cc_quotes = state.get("cc_quotes");
  const cc_quotes_limite2 = state.get("cc_quotes_limite2");
  const cc_quotes_limite3 = state.get("cc_quotes_limite3");
  switch (action.type) {
    case "persist/REHYDRATE":
      if (action.payload) {
        return new Map(action.payload.SegurosCC);
      } else {
        return state;
      }
    case coberturaCompletaAction.CC_POLIZA_EXTRACT:
      return state.set("cc_poliza_datos", action.cc_poliza_datos);
    case coberturaCompletaAction.CC_POLIZA_EXTRACT_ASEGURADORA:
      return state.set("cc_poliza_aseguradora", action.cc_poliza_aseguradora);
    case coberturaCompletaAction.CC_POLIZA_SEGUNDA_PAGINA:
      return state.set(
        "cc_poliza_segundaPagina",
        action.cc_poliza_segundaPagina
      );
    case coberturaCompletaAction.CC_POLIZA_SEGUNDA_PAGINA_DONE:
      return state.set(
        "cc_poliza_segundaPagina_done",
        action.cc_poliza_segundaPagina_done
      );
    case coberturaCompletaAction.CC_POLIZA_ERROR:
      return state.set("cc_poliza_error", action.cc_poliza_error);
    case coberturaCompletaAction.CC_ADD_QUOTE:
      let initialPolicyCounterState = state.get("policyCounter")
        ? state.get("policyCounter")
        : 0;
      const newPolicyCounter = initialPolicyCounterState + 1;
      // Attach the current counter value as an index to the policy
      const newPolicyWithIndex = {
        ...action.cc_quotes,
        index: newPolicyCounter,
      };
      const isEmpty = Object.keys(cc_quotes).length === 0;

      if (isEmpty) {
        // If the array is empty, just add the new quote
        let categorizedPolicy = categorizePolicies(
          [newPolicyWithIndex],
          newPolicyCounter
        );
        return state
          .set("cc_quotes", categorizedPolicy)
          .set("policyCounter", newPolicyCounter);
      } else {
        // If the quote does not exist, add it to the array

        // Check if the quote already exists in the array
        const existingIndex = cc_quotes.findIndex(
          (quote) =>
            quote.aseguradora_cot === action.cc_quotes.aseguradora_cot
        );
        let categorizedPolicies;
        if(existingIndex !== -1){
           categorizedPolicies = categorizePolicies(
            [...cc_quotes],
            newPolicyCounter
          );
        }else{
           categorizedPolicies = categorizePolicies(
            [...cc_quotes, newPolicyWithIndex],
            newPolicyCounter
          );
        }        
        return state
          .set("cc_quotes", categorizedPolicies)
          .set("policyCounter", newPolicyCounter);
      }
    case coberturaCompletaAction.CC_RES_QUOTE:
      return state.set("cc_quotes", action.cc_quotes).set("policyCounter", 0);
    case coberturaCompletaAction.CC_ADD_QUOTE_LIMITE2:
      const isEmpty2 = Object.keys(cc_quotes_limite2).length === 0;

      if (isEmpty2) {
        // If the array is empty, just add the new quote
        return state.set("cc_quotes_limite2", [action.cc_quotes_limite2]);
      } else {
        // Check if the quote already exists in the array
        const existingIndex = cc_quotes_limite2.findIndex(
          (quote) =>
            quote.aseguradora_cot === action.cc_quotes_limite2.aseguradora_cot
        );

        if (existingIndex !== -1) {
          // If the quote exists, replace it
          const updatedQuotes = cc_quotes_limite2.map((quote, index) =>
            index === existingIndex ? action.cc_quotes_limite2 : quote
          );
          return state.set("cc_quotes_limite2", updatedQuotes);
        } else {
          // If the quote does not exist, add it to the array
          return state.set("cc_quotes_limite2", [
            ...cc_quotes_limite2,
            action.cc_quotes_limite2,
          ]);
        }
      }
    case coberturaCompletaAction.CC_RES_QUOTE_LIMITE2:
      return state.set("cc_quotes_limite2", action.cc_quotes_limite2);
    case coberturaCompletaAction.CC_ADD_QUOTE_LIMITE3:
      const isEmpty3 = Object.keys(cc_quotes_limite3).length === 0;
      // if (isEmpty3) {
      //   return state.set("cc_quotes_limite3", [action.cc_quotes_limite3]);
      // }
      // return state.set("cc_quotes_limite3", [
      //   ...cc_quotes_limite3,
      //   action.cc_quotes_limite3,
      // ]);
      if (isEmpty3) {
        // If the array is empty, just add the new quote
        return state.set("cc_quotes_limite3", [action.cc_quotes_limite3]);
      } else {
        // Check if the quote already exists in the array
        const existingIndex = cc_quotes_limite3.findIndex(
          (quote) =>
            quote.aseguradora_cot === action.cc_quotes_limite3.aseguradora_cot
        );

        if (existingIndex !== -1) {
          // If the quote exists, replace it
          const updatedQuotes = cc_quotes_limite3.map((quote, index) =>
            index === existingIndex ? action.cc_quotes_limite3 : quote
          );
          return state.set("cc_quotes_limite3", updatedQuotes);
        } else {
          // If the quote does not exist, add it to the array
          return state.set("cc_quotes_limite3", [
            ...cc_quotes_limite3,
            action.cc_quotes_limite3,
          ]);
        }
      }
    case coberturaCompletaAction.CC_RES_QUOTE_LIMITE3:
      return state.set("cc_quotes_limite3", action.cc_quotes_limite3);
    case coberturaCompletaAction.CC_DEDUCIBLE:
      return state.set("cc_deducible", action.cc_deducible);
    case coberturaCompletaAction.CC_SELECT_SEGURO:
      return state.set("seguroSeleccionado", action.seguroSeleccionado);
    case coberturaCompletaAction.CC_NO_POLIZA:
      return state.set("noPoliza", action.noPoliza);
    case coberturaCompletaAction.CC_CARRO_VIEJO:
      return state.set("carroViejo", action.carroViejo);
    case coberturaCompletaAction.SHOW_SPIN_FORM_CC:
      return state.set("show_spin_form_cc", action.show_spin_form_cc);
    case coberturaCompletaAction.CYBER_FORM_COMPLETED_CC:
      return state.set(
        "cyber_form_completed_cc",
        action.cyber_form_completed_cc
      );
    case coberturaCompletaAction.CYBER_FORM_DATA_CC:
      return state.set("cyber_form_data_cc", action.cyber_form_data_cc);
    case coberturaCompletaAction.CYBER_POST_RESPONSE_CC:
      return state.set("cyber_post_response_cc", action.cyber_post_response_cc);
    case coberturaCompletaAction.EMISION_RESPONSE_CC:
      return state.set("emision_response_cc", action.emision_response_cc);
    case coberturaCompletaAction.EMISION_ERROR_MESSAGE_CC:
      return state.set(
        "emision_error_message_cc",
        action.emision_error_message_cc
      );
    case coberturaCompletaAction.CC_QUOTES_CATEGORY_INTERCOM:
      return state.set(
        "cc_quotes_category_intercom",
        action.cc_quotes_category_intercom
      );
    case coberturaCompletaAction.CC_QUOTE_SELECTED_INTERCOM:
      return state.set(
        "cc_quote_selected_intercom",
        action.cc_quote_selected_intercom
      );
    case coberturaCompletaAction.CC_SET_QUOTES_REFERRAL:
      return state.set("cc_quotes_referral", action.cc_quotes_referral);
    case coberturaCompletaAction.CC_SET_QUOTE_ID:
      return state.set("cc_quote_id", action.cc_quote_id);
    case coberturaCompletaAction.CC_SET_DATA_USER:
      return state.set("cc_data_user", action.cc_data_user);
    case coberturaCompletaAction.CC_SET_INSPECTION_ID:
      return state.set("inspectionId", action.inspectionId);
    default:
      return state;
  }
}
